import React from 'react';
import styles from './ConnectSection.module.css';
import useScrollAnimation from '../../hooks/useScrollAnimation';

// You might want to add actual icons later
const InstagramIcon = () => <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>;
const LinkedInIcon = () => <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>;
const EmailIcon = () => <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>;
const AddressIcon = () => <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;


const ConnectSection = () => {
    const sectionRef = useScrollAnimation();

    return (
        <section id="connect" className={`${styles.connectSection} animate-on-scroll`} ref={sectionRef}>
            <div className="container">
                <h2 className={`section-title ${styles.sectionTitle}`}>Connect With Us</h2>
                <div className={styles.connectGrid}>
                    <div className={styles.connectItem}>
                        <div className={styles.iconWrapper}><InstagramIcon /></div>
                        <h3>Instagram</h3>
                        <a href="https://www.instagram.com/greengrowth.innovations/" target="_blank" rel="noopener noreferrer">@greengrowth.innovations</a>
                    </div>
                    <div className={styles.connectItem}>
                        <div className={styles.iconWrapper}><LinkedInIcon /></div>
                        <h3>LinkedIn</h3>
                        <a href="https://www.linkedin.com/company/green-growth-tech/" target="_blank" rel="noopener noreferrer">Green Growth Tech</a>
                    </div>
                    <div className={styles.connectItem}>
                        <div className={styles.iconWrapper}><EmailIcon /></div>
                        <h3>Email</h3>
                        <a href="mailto:general@greengrowth.tech">general@greengrowth.tech</a>
                    </div>
                    <div className={styles.connectItem}>
                        <div className={styles.iconWrapper}><AddressIcon /></div>
                        <h3>Address</h3>
                        <p>Passeig del Mare Nostrum, 15, Ciutat Vella, 08039 Barcelona</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConnectSection; 